var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-error',{attrs:{"code":"404","text":"Looks like you're lost","message":"The page you are looking for is not available!","button-text":"Get me out of here"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }